const toInfo = (payload) => {

};

export default toInfo;
